import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useMediaQueryContext } from '@fourthwall/components'
import { useOnceInView, useTagManager } from '@hooks'
import { routing } from '@utils/routing'

import { useRecommendationsDismiss } from '../../../Recommendations/hooks/useRecommendationsDismiss'
import type { MiniRecommendationSlideProps } from '../../MiniRecommendations.type'
import * as Carousel from '../../components/Carousel/Carousel'
import { MiniRecommendationDismissButton } from '../../components/MiniRecommendationDismissButton/MiniRecommendationDismissButton'

const ID = 'freeShipping' as const

const CarouselItem = styled(Carousel.Item)`
  background-color: rgba(50, 225, 57, 0.15);

  &:hover {
    background-color: rgba(50, 225, 57, 0.25);
  }
`

export const FreeShippingSlide = ({
  data,
  'data-role': dataRole,
  resetSlider,
}: MiniRecommendationSlideProps) => {
  const { tablet } = useMediaQueryContext()
  const navigate = useNavigate()
  const tagManager = useTagManager()
  const { recommendationsDismiss } = useRecommendationsDismiss()
  const viewRef = useOnceInView(() => {
    tagManager.trigger('mini_recommendation_view', {
      type: ID,
    })
  })
  const alreadyHasFreeShippingPromoActive = data.freeShipping.promotions?.some(
    (promo) => promo.discount.type === 'FREE_SHIPPING' && promo.status.type === 'LIVE',
  )

  if (!recommendationsDismiss.freeShipping.visible || alreadyHasFreeShippingPromoActive) {
    return null
  }

  const redirectToPromotionCodes = () => {
    tagManager.trigger('mini_recommendation_click', {
      type: ID,
    })

    navigate(`${routing.promotions.promotionCodes.create.self}?mode=free-shipping`)
  }

  return (
    <CarouselItem
      ref={viewRef}
      data-role={dataRole}
      data-analytics={ID}
      onClick={redirectToPromotionCodes}
    >
      <Carousel.ContentLeft>
        <Carousel.ItemEmote>🚛</Carousel.ItemEmote>
        {!tablet && <Carousel.ItemText>Free shipping over $75</Carousel.ItemText>}
        {tablet && (
          <Carousel.ItemText>Tip: Offer free shipping on orders over $75</Carousel.ItemText>
        )}
      </Carousel.ContentLeft>

      {recommendationsDismiss.freeShipping.visible && (
        <MiniRecommendationDismissButton
          onDismiss={() => {
            recommendationsDismiss.freeShipping.dismiss()
            tagManager.trigger('mini_recommendation_dismiss', {
              type: ID,
            })
            setTimeout(() => {
              resetSlider()
            }, 0)
          }}
        />
      )}
    </CarouselItem>
  )
}
